import script from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"
export * from "./UploadFolderDetails.vue?vue&type=script&setup=true&lang=ts"

import "./UploadFolderDetails.vue?vue&type=style&index=0&id=8f5940d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f5940d8"]])

export default __exports__